import type { FaireProductEntity } from "../../entity_types/product";

export const p_keq5d5424n: FaireProductEntity = {
  token: "p_keq5d5424n",
  type: "product",
  name: "Butter Mini Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/e5d24e741f13a6c87f475a82d8c350e557d5971e45b2d120cfec046aaff29441.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e97540daae2ac0c33b97d6c801392c674b479e01ff2316f83d3c8b8741cbacd6.jpeg"
  ],
  priceDollars: 8,
  description: "Small but mighty.\n\nGood things come in small(er) packages. The Mini Towel (previously known as our Bar Towel) brings all the power and performance of our Tea Towel in a more compact design. Same towel, smaller size, same Geoweave™ fabric. Just a new name.\n\nCreated from a tightly-woven Geoweave™ fabric that's ultra-absorbent, quick-drying and never wrinkles, this towel is built to work while looking like a dream. A sewn-in loop makes it easy to hang anywhere, a bar cart, fridge handle, oven door, or hooked over your shoulder mid-prep.\n\n... \n\n * ♺ Made from post-consumer recycled materials \n * 12\" x 24\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n... \n\nChore responsibly. \n\nFrom drying glassware to wiping up spills to accenting your kitchen with the season’s most captivating prints, the mini towel is your kitchen’s best friend – and a friend to the environment. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:46.279Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
